import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SnackBarService} from '../../../shared/services/snackbar.service';
import {GlobalSpinnerService} from '../../../shared/components/loader-service/global-spinner.service';
import {ActivityStatusTypeLabelKLDomain} from '../../../shared/domain/activity-status.model';
import {PodcastClip, RSSFeed} from '../../../shared/domain/rss.model';
import {PublisherDashboardService} from '../../dashboard/publisher-dashboard.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatAutocompleteSelectedEvent} from '@angular/material';
import {map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'cm-rss-edit-dialog',
  templateUrl: './podcast-clip-edit-dialog.component.html',
  styleUrls: ['./podcast-clip-edit-dialog.component.scss']
})
export class PodcastClipEditDialogComponent implements OnInit {

  activityStatuses = ActivityStatusTypeLabelKLDomain();
  clip: PodcastClip;
  rssFeed: RSSFeed;

  isUpdate = true;
  typeFormGroup: FormGroup;
  filteredLanguageCodes: Observable<Map<String, String>>;
  audioDisplay: FormControl = new FormControl("", Validators.required);
  imageDisplay: FormControl = new FormControl("", Validators.required);

  audioFileStore: FileList;
  audioFileList: Array<string> = [];

  imageFileStore: FileList;
  imageFileList: Array<string> = [];
  public myControl: FormControl = new FormControl('');
  constructor(public dialogRef: MatDialogRef<PodcastClipEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private dashboardService: PublisherDashboardService,
    private gss: GlobalSpinnerService,
    private sbs: SnackBarService,
              private fb: FormBuilder) {

    if (data && data.record) {
      this.clip = data.record;
    }

    if (data && data.rss_record) {
      this.rssFeed = data.rss_record;
    }

    if (data && data.isUpdate !== undefined) {
      this.isUpdate = data.isUpdate;
    }
  }

  ngOnInit(): void {
    this.typeFormGroup = this.fb.group({
      radio: new FormControl('', Validators.required)
    });

    if (this.clip != null) {
      this.filteredLanguageCodes = this.myControl.valueChanges
        .pipe(
          startWith(this.data.languageCodes.get(this.clip.channelLanguage)),
          map(value => this._filter(value))
        );
    }

  }

  saveFeed() {
    this.gss.showLoader();

    if (this.isUpdate) {
      this.dashboardService.updateFeed(this.rssFeed).subscribe(next => {
        this.gss.hideLoader();
        this.sbs.success('Podcast Feed has been successfully updated');
        this.dialogRef.close(next);
      }, error => {
        this.sbs.error(error.error.error.messages[0]);
        this.gss.hideLoader();
      });
    } else {
      this.dashboardService.createFeed(this.rssFeed).subscribe(next => {
        this.gss.hideLoader();
        this.sbs.success('Podcast Feed has been successfully created');
        this.dialogRef.close(next);
      }, error => {
        this.sbs.error(error.error.error.messages[0]);
        this.gss.hideLoader();
      });
    }
  }

  saveClip() {
    this.gss.showLoader();

    const audioFile = this.audioFileStore !== undefined && this.audioFileStore.length > 0 ? this.audioFileStore[0] : null;
    const imageFile = this.imageFileStore !== undefined && this.imageFileStore.length > 0 ? this.imageFileStore[0] : null;

    if (this.isUpdate) {
      this.dashboardService.updatePodcastClip(this.clip, audioFile, imageFile).subscribe(next => {
        this.gss.hideLoader();
        this.sbs.success('Podcast Clip has been successfully updated');
        this.dialogRef.close(next);
      }, error => {
        this.sbs.error(error.error.error.messages[0]);
        this.gss.hideLoader();
      });
    } else {
      this.dashboardService.createPodcastClip(this.clip, audioFile, imageFile).subscribe(next => {
        this.gss.hideLoader();
        this.sbs.success('Podcast Clip has been successfully created');
        this.dialogRef.close(next);
      }, error => {
        this.sbs.error(error.error.error.messages[0]);
        this.gss.hideLoader();
      });
    }
  }

  onFilterOptionSelected($event: MatAutocompleteSelectedEvent) {

  }

  private _filter(value: string): Map<String, String> {
    if (value === undefined) {
      return this.data.languageCodes;
    } else {
      const filterValue = value.toLowerCase();

      return new Map(
        // @ts-ignore
        Array.from(this.data.languageCodes.entries()).filter(([key, value]) => value.toLowerCase().includes(filterValue))
      );
    }
  }

  displayFn(key?: string) {
    return key ? this.data.languageCodes.get(key) : undefined;
  }

  handleAudioFileInputChange(files: FileList) {
    console.log('inside handleAudioFileInputChange');
    if (files.length) {
      const f = files[0];
      if (f.size > 20 * 1024 * 1000) {
        this.sbs.error('Select file is too large. Please choose a file less than 20 MB');
      } else {
        this.audioFileStore = files;

        const count = files.length > 1 ? `(+${files.length - 1} files)` : '';
        this.audioDisplay.patchValue(`${f.name}${count}`);
      }

    } else {
      this.audioDisplay.patchValue('');
    }
  }

  handleImageFileInputChange(files: FileList) {
    if (files.length) {
      const f = files[0];
      if (f.size > 5 * 1024 * 1000) {
        this.sbs.error('Select file is too large. Please choose a file less than 5 MB');
      } else {
        this.imageFileStore = files;

        const count = files.length > 1 ? `(+${files.length - 1} files)` : '';
        this.imageDisplay.patchValue(`${f.name}${count}`);
      }

    } else {
      this.imageDisplay.patchValue('');
    }

  }
}
